// extracted by mini-css-extract-plugin
export default {"devPriority":"DevCategoryPriority_devPriority__Nx4x3"};